export default __webpack_public_path__ + "static/media/people4.c53b1071.jpeg";